"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var as_html_element_1 = require("@opten/dom/as-html-element");
var has_class_1 = require("@opten/dom/has-class");
var is_html_element_1 = require("@opten/dom/is-html-element");
var __1 = require("../");
var reflector_1 = require("../reflector");
var resolver_1 = require("../resolver");
// todo: cache, static, inject?
var reflector = new reflector_1.Reflector();
var resolver = new resolver_1.Resolver(reflector);
var compiler = new __1.Compiler(resolver);
function factory(components) {
    return function (rootElement) {
        var observables = new Map();
        components.forEach(function (componentType) {
            // todo: inject resolver, or cache?
            // todo: static or something to cache?
            var component = resolver.resolve(componentType);
            if (component) {
                Array.from(document.getElementsByClassName(component.className)).forEach(function (node) {
                    return compiler.compile(component, node, componentType);
                });
                if (component.observe) {
                    observables.set(component, componentType);
                }
            }
            else {
                throw new Error("No @Component annotation for " + (componentType ? componentType.name : componentType) + " found!");
            }
        });
        if (observables.size) {
            new MutationObserver(function (mutations) {
                var componentInitializer = new Map();
                mutations.forEach(function (mutation) {
                    observables.forEach(function (value, key) {
                        return Array.from(mutation.addedNodes)
                            .filter(function (node) { return is_html_element_1.default(node); })
                            .map(function (node) { return as_html_element_1.default(node); })
                            .forEach(function (node) {
                            var comps = Array.from(node.getElementsByClassName(key.className));
                            if (has_class_1.default(node, key.className)) {
                                comps.push(node);
                            }
                            comps.forEach(function (component) {
                                componentInitializer.set(component, function () {
                                    return compiler.compile(key, component, value);
                                });
                            });
                        });
                    });
                });
                componentInitializer.forEach(function (c) { return c(); });
            }).observe(rootElement, {
                childList: true,
                subtree: true
            });
        }
    };
}
exports.default = factory;
